export default __webpack_public_path__ + "4342955e9716aca227060c48ced76bac.webp";